
import { defineComponent } from 'vue';
import { Vue3Lottie } from 'vue3-lottie';

import { useLoading } from '@hems/util/src/composable/loading';

export default defineComponent({
  name: 'Loading',
  components: {
    Vue3Lottie,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { isLoading } = useLoading();

    return {
      isLoading,
    };
  },
});
